import cookieManager from 'js-cookie';

export enum StatusType {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  WAITING = 'WAITING',
  LOADING = 'LOADING',
  ERROR = 'ERROR',
}

export function getLiveChatStatus() {
  if (window.Intercom) {
    return StatusType.AVAILABLE;
  } else {
    return StatusType.UNAVAILABLE;
  }
}

export function destroyLiveChat(): void {
  if (window.Intercom) {
    window.Intercom('shutdown');
  } else {
    deleteIntercomSession();
  }
}

function deleteIntercomSession(): void {
  document.cookie
    .split(';')
    .map((cookie) => cookie.trim())
    .filter((cookie) => /^intercom-.*$/.test(cookie))
    .map((s) => s.split('=')[0])
    .forEach((cookie) => {
      cookieManager.remove(cookie, {
        path: '/',
        ...(window.location.host !== 'localhost' && {
          domain: `.${window.location.host.substring(window.location.host.indexOf('.') + 1)}`,
        }),
      });
    });

  Object.keys(sessionStorage)
    .filter((key) => /^intercom.*$/.test(key))
    .forEach((key) => {
      sessionStorage.removeItem(key);
    });
  Object.keys(localStorage)
    .filter((key) => /^intercom.*$/.test(key))
    .forEach((key) => {
      localStorage.removeItem(key);
    });
}
